import { useContext } from 'react'

import { Form } from 'components/Form'
import { DomainsTable } from 'features/inventory/domain/components/DomainsTable'
import { DomainListContext } from 'features/inventory/domain/contexts/DomainListContext'
import { useSaveDomainProducts } from './hooks/useSaveDomainProducts'
import { domainTableSchema, DomainTableSchema, domainTableSchemaDefault } from './schema'

export const DomainTableForm = (): React.JSX.Element => {
  const { formId, setTouched, setValid } = useContext(DomainListContext)
  const { loading, update } = useSaveDomainProducts()

  return (
    <Form<DomainTableSchema>
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={domainTableSchema}
      schemaDefaults={domainTableSchemaDefault}
    >
      {() => <DomainsTable />}
    </Form>
  )
}
